import { UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';
import { useFetcher, useLoaderData } from 'react-router-dom';
import FileManager from '../../../components/inputs/fiel-manager';
import DocumentsDownloader from '../../template/documentDownloader';
import styles from './artwork-recieved.module.scss';

const ArtWorkReceived = () => {
    const { artworkData, productionDetails } = useLoaderData()
    const [isModalOpen, setModalOpen] = useState(false)
    const fetcher = useFetcher()
    return (<div className={styles.container}>
        <h3>Task for you</h3>
        <div className={styles.outerBox}>
            <div className={styles.artworkBox}>
                <div className={styles.taskIntro}>
                    <div>
                        <span className={styles.label}>Artwork received</span>
                        <p>Leoprinting has uploaded the artwork. Please create a printable final proof and upload it.</p>
                    </div>
                    <Button type='primary' ghost={true} icon={<UploadOutlined />} onClick={() => { setModalOpen(true) }}>Upload Final Proof</Button>
                </div>
                {!!artworkData.comments && (
                    <div className={styles.commentBox}><strong>Comment</strong><span>{artworkData.comments}</span></div>
                )}
                {!!artworkData.document?.length && (
                    <div className={styles.documentList}>
                        {artworkData.document.map(({ url, name, comment }) => <DocumentsDownloader key={url} image={url} name={name} comment={comment} project_id={productionDetails.project_id} itemId={productionDetails.id} />)}
                    </div>
                )}
            </div>
        </div>
        <br />
        <FileManager
            isOpen={isModalOpen}
            title="Send Proof to Leoprinting"
            project_id={productionDetails?.project_id}
            item_id={productionDetails?.id}
            onUpload={(imageData) => {
                fetcher.submit({
                    imageData: imageData,
                    id: productionDetails.id,
                    action: 'sendProof'
                }, {
                    method: 'post',
                    encType: 'application/json'
                })
            }}
            actionButtonText='Upload & Send'
            onClose={() => setModalOpen(false)}
        />
    </div>
    )

}

export default ArtWorkReceived;
